import InstagramMediaContext from './InstagramMediaContext';
import {
  InstagramMediaContextProvider,
} from './InstagramMediaContextProvider';

export default InstagramMediaContext;
export {
  InstagramMediaContextProvider,
};
